import React from "react";
import { EditorField } from "../../../../store";
import { TextField, PhoneField, getFieldIcon } from "@codway-dev/ui";

interface InputPreviewProps {
  field: EditorField;
  dynamicStyle: React.CSSProperties;
  onUpdate: (value: string) => void;
  error?: string;
}

export const TextInputPreview: React.FC<InputPreviewProps> = ({
  field,
  dynamicStyle,
  onUpdate,
  error,
}) => {
  const icon = field.show_icon
    ? getFieldIcon(field.key, field.type)
    : undefined;

  if (field.type === "tel") {
    return (
      <div style={dynamicStyle as React.CSSProperties}>
        <PhoneField
          id={field.key || field.tempId}
          label={field.label}
          value={field.defaultValue || ""}
          prefix="+XX"
          onChange={onUpdate}
          placeholder={
            ("placeholder" in field && field.placeholder) || undefined
          }
          required={field.required}
          error={error}
          icon={icon}
        />
      </div>
    );
  }

  return (
    <div style={dynamicStyle as React.CSSProperties}>
      <TextField
        id={field.key || field.tempId}
        label={field.label}
        value={field.defaultValue || ""}
        type={field.type as "text" | "email" | "number" | "date" | "textarea"}
        onChange={onUpdate}
        placeholder={("placeholder" in field && field.placeholder) || undefined}
        required={field.required}
        error={error}
        icon={icon}
      />
    </div>
  );
};
